import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { InlineSlideViewer } from '../../../../components/InlineSlideViewer';
import DownloadIcon from '@mui/icons-material/Download';
import CircularProgress from '@mui/material/CircularProgress';

interface SlideLightboxProps {
  exportId: string;
  iterationFqn: string;
  fileCount: number;
  onClose: () => void;
  onDownloadPptx: () => void;
  isDownloadingPptx: boolean;
}

export const SlideLightbox: React.FC<SlideLightboxProps> = ({
  exportId,
  iterationFqn,
  fileCount,
  onClose,
  onDownloadPptx,
  isDownloadingPptx,
}) => {
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        onClose();
      }
    };

    window.addEventListener('keydown', handleEscape, true);
    return () => window.removeEventListener('keydown', handleEscape, true);
  }, [onClose]);

  return createPortal(
    <div className="image-lightbox-overlay" data-modal-root="true" onClick={onClose}>
      <div className="image-lightbox-content" style={{ flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <button className="image-lightbox-close" onClick={onClose}>×</button>
        <div className="slide-lightbox-slide">
          <InlineSlideViewer
            exportId={exportId}
            iterationFqn={iterationFqn}
            fileCount={fileCount}
          />
        </div>
        <button
          className="slide-lightbox-download"
          onClick={onDownloadPptx}
          disabled={isDownloadingPptx}
          title={isDownloadingPptx ? 'Downloading...' : 'Download PowerPoint'}
        >
          {isDownloadingPptx ? (
            <CircularProgress size={14} color="inherit" />
          ) : (
            <DownloadIcon style={{ fontSize: 16 }} />
          )}
          {isDownloadingPptx ? 'Downloading...' : 'Download PPT'}
        </button>
      </div>
    </div>,
    document.body
  );
};
